import React from 'react'

const Digital = () => {
  return (
    <>
      <h1>Welcome to Digital Marketing</h1>
    </>
  )
}

export default Digital
